import React from 'react'


class Mobile extends React.Component{
    constructor () {
        super();
        this.state = { module : "IPhone 13 Pro Max"}

    }

    render () {
        return <>
            <h1> Mobile Model is { this.state.module } </h1>
            <button type ="button" onClick= { () => {
             this.setState({module : "IPhone 14 Pro"}) }}> Check to see Current model </button>
        </>
    }
}


export default Mobile;